import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const officesAdapter = createEntityAdapter({})

const initialState = officesAdapter.getInitialState()

export const officeApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getoffices: builder.query({
            query: () => ({
                url: '/offices',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedoffices = responseData.map(office => {
                    office.id = office._id
                    return office
                });
                return officesAdapter.setAll(initialState, loadedoffices)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'OFFICE', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'OFFICE', id }))
                    ]
                } else return [{ type: 'OFFICE', id: 'LIST' }]
            }
        }),
        addNewoffice: builder.mutation({
            query: initialUserData => ({
                url: '/offices',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'OFFICE', id: "LIST" }
            ]
        }),
        addBulkoffice: builder.mutation({
            query: initialUserData => ({
                url: '/offices/addbulk',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'OFFICE', id: "LIST" }
            ]
        }),
        updateoffice: builder.mutation({
            query: initialUserData => ({
                url: '/offices',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'OFFICE', id: arg.id },
                { type: 'OFFICE', id: 'LIST' }
            ]
        }),        
        deleteoffice: builder.mutation({
            query: ({ id }) => ({
                url: `/offices`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'OFFICE', id: arg.id },
                { type: 'OFFICE', id: 'LIST' }
            ]
        }),
    }),
})

export const {
    useGetofficesQuery,
    useAddNewofficeMutation,
    useAddBulkofficeMutation,
    useUpdateofficeMutation,
    useDeleteofficeMutation, 
} = officeApiSlice

// returns the query result object
export const selectofficesResult = officeApiSlice.endpoints.getoffices.select()

// creates memoized selector
const selectofficesData = createSelector(
    selectofficesResult,
    officesResult => officesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAlloffices,
    selectById: selectofficeById,
    selectIds: selectofficeIds
    // Pass in a selector that returns the users slice of state
} = officesAdapter.getSelectors(state => selectofficesData(state) ?? initialState)